export enum IdTipoAnomalia {
    FaltaPedidoLiminar = 1,
    OutrosPedidosLiminar = 2
}